module.exports = __webpack_public_path__ + "img/webworthy-screens.bbcecc6b.png";